import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { ForeignNews } from "../home/templates";
import {
  NewsCard,
  NewsGroup,
  PageNavigation,
  Pagination,
  TopMenu,
} from "../../components";
import { getLanguage } from "../../utils/environment";
import { useLocation } from "react-router-dom";
import { getNewsByTag } from "../news/service/news.service";
import { Helmet } from "react-helmet";
import {
  CategoryRightTopAdd,
  ConsoleTopLeftAdd,
  ConsoleTopRightAdd,
} from "../templates/advertiesments";
import TopNews from "../templates/topTagNews";
import useTags from "../../config/tags";
import { GetIconByName } from "../../config/icon";
import { openMobileMenuModal } from "../console/redux/actions";
import Menu from "../templates/menu";
import { MobileMenuModal } from "../modal";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { getNewsByTags } from "../newsViewPage/service/news.service";

const lan = getLanguage();

const Index = (props) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [tag, setTag] = React.useState("");
  const [pageNo, setPageNo] = useState("");
  const [pageCount, setPageCount] = useState(0);

  const dispatch = useDispatch();
  const history = useHistory();

  const { isOpenMobileMenuModal } = useSelector(
    ({ consoleReducer }) => consoleReducer
  );

  const { getTagName } = useTags();

  useEffect(() => {
    window.scrollTo(0, 0);
    let param = location.pathname.split("/");
    console.log({ param });
    let newTag = param[3];
    if (news?.length < 0 || newTag !== tag) {
      setIsLoading(true);
      fetchPageData(newTag);
    }
  }, [location.pathname]);

  const onChangeMenu = (tag) => {
    props.onChangeTag(tag);
  };

  async function fetchPageData(tag) {
    let param = window.location.pathname;
    param = param.split("/");
    console.log({ param });
    if ((param && param[1]) || tag) {
      const tagId = param[3] || tag;
      const tagName = param[2];
      console.log({ tagId });
      setTag({ tagId: tagId || tag, tagName: getTagName(tagId)?.name || "" });
      try {
        let response = await getNewsByTags({ tag_ids: [tagId] });
        console.log("tags_news", response);
        if (response?.data) {
          setNews(response?.data?.news);
          setPageCount(response?.data?.count);
          setPageNo(1);
        } else {
          setNews([]);
        }
        setIsLoading(false);
      } catch (error) {
        console.log({ error });
        setIsLoading(false);
      }
    }
  }

  const handleChildData = (childData) => {
    // props.onChangeCategory(childData); // Update state with child data
    // setCategory(childData);
  };

  const onChangePage = async (pageNumber) => {
    // setIsLoading(true);
    // try {
    //   let response = await getNewsBytag(tag, 5, pageNumber);
    //   console.log("response next::", response);
    //   if (response?.data?.news?.length > 0) {
    //     setNews(response?.data?.news);
    //     setPageNo(pageNumber);
    //     window.scrollTo(0, 0);
    //   }
    //   // setIsLoading(false);
    // } catch (error) {
    //   console.log({ error });
    //   setIsLoading(false);
    // }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    let param = location.pathname.split("/");
    console.log({ param });
    let newTag = param[1];
    if (news?.length < 0) {
      setIsLoading(true);
      fetchPageData(newTag);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{tag?.tagName || "Hope of a New Era – News by tag"}</title>
        <meta
          name="description"
          content={`Read the latest news on ${
            tag?.tagName || "various topics"
          } from Hope of a New Era.`}
        />
        <meta
          name="keywords"
          content={`Sri Lanka news, ${tag?.tagName || ""}`}
        />
        <meta name="author" content="Hope of a New Era" />
        <meta property="og:title" content={tag?.tagName} />
        <meta
          property="og:description"
          content={`Latest news articles under ${
            tag?.tagName || "various topics"
          }`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={tag?.tagName || "Hope of a New Era"}
        />
        <meta
          name="twitter:description"
          content={`Explore current stories about ${
            tag?.tagName || "Sri Lanka topics"
          }`}
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {isOpenMobileMenuModal && <MobileMenuModal />}
      <div className={"bg-image"}></div>{" "}
      <img className={"bg__img"} src={news?.images?.[0]?.url} alt={""} />
      <div>
        <TopMenu
          data={{
            size: "lg",
            isLanguage: true,
            isLogo: false,
            isProfile: false,
          }}
          onClickPublish={() => {
            history.push("/admin");
          }}
        />
      </div>
      <div className={"container"}>
        <div className={"cw__tab"}>
          <div className={"cwt__hope"}>
            {/* නවයුගයක පැතුමක් */}
            <img
              src={require("../../assets/img/lgo (1).png")}
              alt={news?.title?.[lan]}
              //style={{ marginRight: "17px" }}
            />
          </div>
          <div className={"menu"}>
            <Menu setMenuName={handleChildData} />
          </div>

          <div
            className={"cwt__menu-mobile"}
            onClick={() => {
              dispatch(openMobileMenuModal());
            }}
          >
            {GetIconByName("menu")}
          </div>
        </div>
        <div className={"cw__advertiesment-wrapper"}>
          {/* <div className={"cwa__advertiesment"}>Advertisement with us </div>
                  <div className={"cwa__advertiesment"}>Advertisement with us </div> */}
          <div className={"cwaw__first"}>
            <ConsoleTopLeftAdd />
          </div>
          <ConsoleTopRightAdd />
        </div>
        <PageNavigation
          data={{
            main: "Home",
            page: " tags > " + tag?.tagName,
          }}
          onClick={() => history.push("/")}
        />
        <div className={`hot-news-wrapper mt-2`}>
          <>
            <div className={"hw__special-news-group"}>
              {/* <div className={"hwsng__advertiesment"}>Advertisement with us </div> */}
              {/*<tagLeftTopAdd />*/}

              {!isLoading && (
                <NewsGroup
                  data={{
                    titleName: tag?.tagName || "",
                    linkName: (
                      <>
                        {pageCount > news?.length && (
                          <div
                            className={
                              "d-flex flex-column justify-content-center align-items-center mt-5"
                            }
                          >
                            <Pagination
                              data={{
                                paginationCount: pageCount,
                                pageNo: pageNo,
                              }}
                              onChange={onChangePage}
                            />
                          </div>
                        )}
                      </>
                    ),

                    // lan === "en"
                    //   ? "More " + tag?.tagName
                    //   : "තවත් " + tag?.tagName,
                  }}
                  onClickViewNews={() => {
                    onChangePage(pageNo + 1);
                  }}
                >
                  {/* {news?.map((item, index) => (
                  <NewsCard
                    data={{ type: "large", isBorder: true }}
                    item={item}
                  />
                ))} */}
                  {!isLoading &&
                    news.map((item, index) => {
                      // Check if the item has updates
                      const hasUpdates =
                        Array.isArray(item.updates) && item.updates.length > 0;

                      // If updates exist, use the latest update (or modify as needed)
                      const displayItem = hasUpdates
                        ? { ...item, ...item.updates[item.updates.length - 1] }
                        : item;

                      return (
                        <React.Fragment key={index}>
                          <NewsCard
                            key={index}
                            data={{
                              type: "large",
                              isBorder: true,
                              isUpdate: hasUpdates,
                            }}
                            item={displayItem}
                            onClick={() => {
                              if (displayItem?.keywords?.[lan]) {
                                window.open(
                                  `/${displayItem?.keywords?.[lan]}/${displayItem?.news_id}`
                                );
                              } else {
                               
                                const generatedSlug = displayItem?.title?.[lan]
                                ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                                ?.replace(/\//g, "")
                                ?.replace(/\s*-\s*/g, " ")
                                ?.trim()
                                .split(/\s+/)
                                .slice(0, 5)
                                .join("-")
                                .replace(/-+/g, "-");
                              window.open(
                                `/${generatedSlug}/${displayItem?.news_id}`
                              );;
                              }
                            }}
                            onChangeTag={onChangeMenu}
                          />
                        </React.Fragment>
                      );
                    })}
                </NewsGroup>
              )}
              <TopNews />

              {/* {tag !== "67d841d3ec995c0cecc999c2" && (
                <HotNews setMenuName={onChangeMenu} setTagData={onChangeMenu} />
              )} */}
            </div>

            <div className={"hw__special-news-group"}>
              <CategoryRightTopAdd />
              <ForeignNews
                setMenuName={onChangeMenu}
                setTagData={onChangeMenu}
              />
            </div>
          </>
          {isLoading && (
            <div className="hw__special-news-group">Loading... </div>
          )}
        </div>
      </div>
    </>
  );
};
export default Index;
